import { render, staticRenderFns } from "./propostaLista.vue?vue&type=template&id=79d11422"
import script from "./propostaLista.vue?vue&type=script&lang=js"
export * from "./propostaLista.vue?vue&type=script&lang=js"
import style0 from "./propostaLista.vue?vue&type=style&index=0&id=79d11422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports